const AValidate = (rule, val) => {
    
    const result = {
        status: false,
        msg: null
    }

    if (!rule) return result

    if (rule(val) !== true) {
        result.status = true
        result.msg = rule(val)
    }

    return result

}

export {
    AValidate
}